export default "__VITE_PUBLIC_ASSET__85335287__"